import React, { Component } from "react";
import PageWrapper from "../../components/PageWrapper/PageWrapper";
import { withPrismic } from "../../components/Prismic/Prismic";
import { Helmet } from "react-helmet";
import Loading from "../../components/Loading/Loading";
import NotFound from "../NotFound/NotFound";
import RichText from "../../components/RichText/RichText";
import './Page.css';
import {DefaultMetaTags} from "../../config";

class Page extends Component {

	constructor(props) {
		super(props);
		this.state = {
			uid : null
		}
	}
	
	loadPage() {
		this.setState({uid : this.props.uid});
		this.props.prismic.getPage(this.props.uid, this.props.lang);
	}

	componentDidMount() {
		if(!this.props.prismicContext) return null;
		this.loadPage();
	}

	componentDidUpdate() {
		
		if(this.state.uid && this.props.uid === this.state.uid) return null;
		this.loadPage();
	}
	
	render() {
		if(this.props.error) return <NotFound />;

		if(!this.props.content) return <Loading />;	

		return (
			<PageWrapper context={`page -${this.props.content.uid}`} full={true}>
			<Helmet title={this.props.content.data.title[0].text} />
			<DefaultMetaTags title={this.props.content.data.title[0].text} />
			<section className="header">
			<div className="container">
			<div className="content">
			<RichText content={this.props.content.data.title} />
			</div>
			</div>
			</section>
			<section className="body">
			<div className="container">
			<div className="content">
			<RichText content={this.props.content.data.body} slices={this.props.content.data.page_slices} />
			</div>
			</div>
			</section>
			</PageWrapper>
		);
	}
}

export default withPrismic(Page);



// WEBPACK FOOTER //
// ./src/pages/Page/Page.js